// product page gallery with PhotoSwipe Start
'use strict';

// Use event delegation to catch clicks on any gallery anchor—even dynamically added ones.
document.body.addEventListener('click', function (event) {
    // Look for a click on an <a> element within a gallery container.
    // (Make sure your gallery container has the class "kiks-custom-media-gallery-js".)
    var clickedAnchor = event.target.closest('.kiks-custom-media-gallery-js a');
    if (!clickedAnchor) {
        return; // Not a gallery item.
    }

    event.preventDefault(); // Prevent the default link behavior.

    // Get the closest gallery container.
    var galleryContainer = clickedAnchor.closest('.kiks-custom-media-gallery-js');
    if (!galleryContainer) {
        console.error('Gallery container not found.');
        return;
    }

    // Build the gallery items array from this container.
    var galleryAnchors = galleryContainer.querySelectorAll('a');
    var items = [];
    galleryAnchors.forEach(function (anchor, idx) {
        // Store index on each anchor
        anchor.dataset.pswpIndex = idx;
        items.push({
            src: anchor.getAttribute('href'),
            w: parseInt(anchor.dataset.width, 10) || 0,
            h: parseInt(anchor.dataset.height, 10) || 0,
            title: anchor.dataset.caption || ''
        });
    });

    // Get the index of the clicked item.
    var index = parseInt(clickedAnchor.dataset.pswpIndex, 10);
    if (isNaN(index) || index < 0 || index >= items.length) {
        console.error('Invalid gallery index:', index);
        return;
    }

    // Make sure the PhotoSwipe element exists.
    var pswpElement = document.querySelector('.pswp');
    if (!pswpElement) {
        console.error('PhotoSwipe element not found.');
        return;
    }

    // Define options with a getThumbBoundsFn that works for this gallery.
    var options = {
        index: index,
        bgOpacity: 0.85,
        showHideOpacity: true,
        showAnimationDuration: 300,
        hideAnimationDuration: 300,
        history: false,
        focus: false,
        escKey: true,
        arrowKeys: true,
        getThumbBoundsFn: function (i) {
            var thumbAnchor = galleryAnchors[i];
            if (thumbAnchor) {
                // Look for an <img> inside the anchor.
                var thumbImage = thumbAnchor.querySelector('img');
                if (thumbImage) {
                    var rect = thumbImage.getBoundingClientRect();
                    // Ensure width is nonzero (use a fallback value if needed)
                    var thumbWidth = rect.width || 100;
                    return {
                        x: rect.left,
                        y: rect.top + window.pageYOffset,
                        w: thumbWidth
                    };
                }
            }
            // Fallback: always return an object, never false.
            return { x: 0, y: 0, w: 100 };
        }
    };

    // Make sure PhotoSwipe and its UI are loaded.
    if (typeof PhotoSwipe !== 'function' || typeof PhotoSwipeUI_Default !== 'function') {
        console.error('PhotoSwipe or PhotoSwipeUI_Default is not properly defined.');
        return;
    }

    try {
        // Initialize PhotoSwipe with the dynamic items and options.
        var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    } catch (error) {
        console.error('Error initializing PhotoSwipe:', error);
    }
});

// product page gallery with PhotoSwipe End

// Global
// Add z-index when cart icon is clicked
document.querySelector('a#cart-icon').addEventListener('click', function () {
    // Add z-index to #shopify-chat
    const shopifyChat = document.querySelector('div#shopify-chat');
    if (shopifyChat) {
        shopifyChat.style.zIndex = '9';
    }

    // Add z-index to inbox-online-store-chat#ShopifyChat
    const inboxChat = document.querySelector('inbox-online-store-chat#ShopifyChat');
    if (inboxChat) {
        inboxChat.style.zIndex = '9';
    }

    // Add z-index to one-loyalty-widget
    const loyaltyWidget = document.querySelector('one-loyalty-widget section.one-loyalty__popup-widget');
    if (loyaltyWidget) {
        loyaltyWidget.style.zIndex = '9';
    }
});

// Remove z-index when close cart button is clicked
document.querySelector('button#CloseCart').addEventListener('click', function () {
    // Reset z-index to default for #shopify-chat
    const shopifyChat = document.querySelector('div#shopify-chat');
    if (shopifyChat) {
        shopifyChat.style.zIndex = ''; // Removes inline zIndex
    }

    // Reset z-index for inbox-online-store-chat#ShopifyChat
    const inboxChat = document.querySelector('inbox-online-store-chat#ShopifyChat');
    if (inboxChat) {
        inboxChat.style.zIndex = ''; // Removes inline zIndex
    }

    // Reset z-index for one-loyalty-widget
    const loyaltyWidget = document.querySelector('one-loyalty-widget section.one-loyalty__popup-widget');
    if (loyaltyWidget) {
        loyaltyWidget.style.zIndex = ''; // Removes inline zIndex
    }
});

// Remove z-index when div#CartDrawer display is set to none
const cartDrawer = document.querySelector('div#CartDrawer');
if (cartDrawer) {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.attributeName === 'style' && cartDrawer.style.display === 'none') {
                // Reset z-index for #shopify-chat
                const shopifyChat = document.querySelector('div#shopify-chat');
                if (shopifyChat) {
                    shopifyChat.style.zIndex = ''; // Removes inline zIndex
                }

                // Reset z-index for inbox-online-store-chat#ShopifyChat
                const inboxChat = document.querySelector('inbox-online-store-chat#ShopifyChat');
                if (inboxChat) {
                    inboxChat.style.zIndex = ''; // Removes inline zIndex
                }

                // Reset z-index for one-loyalty-widget
                const loyaltyWidget = document.querySelector('one-loyalty-widget section.one-loyalty__popup-widget');
                if (loyaltyWidget) {
                    loyaltyWidget.style.zIndex = ''; // Removes inline zIndex
                }
            }
        });
    });

    // Observe changes to the style attribute of div#CartDrawer
    observer.observe(cartDrawer, { attributes: true });
}


